import React from "react";

export const highlightMatch = (text, searchTerm) => {
  if (!searchTerm) return text;

  const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
  return (
    <span>
      {parts.map((part, i) =>
        part.toLowerCase() === searchTerm.toLowerCase() ? (
          <mark key={i} className="search-highlight">
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </span>
  );
};

export const estimateTimeFromWordPosition = (
  transcript,
  searchTerm,
  videoDuration
) => {
  const words = transcript.toLowerCase().split(/\s+/);
  const searchTermLower = searchTerm.toLowerCase();

  // Find the first occurrence of the search term
  const wordIndex = words.findIndex((word) => word.includes(searchTermLower));
  if (wordIndex === -1) return 0;

  // Estimate time based on word position
  // Assumes words are evenly distributed throughout the video
  const approximateTime = (wordIndex / words.length) * videoDuration;
  return Math.floor(approximateTime);
};